import React from "react";
import cs from "classnames";
import PropTypes from "prop-types";

import PageTitle from "../../atoms/PageTitle";
import { PAGE_TITLES } from "../../../constants";

import classes from "./AccessDenied.module.scss";
import { useQuery } from "../../../hooks";

const AccessDenied = ({ ip: propIp = "" }) => {
  const query = useQuery();
  const ip = query.get("ip") || propIp;

  return (
    <>
      <PageTitle value={PAGE_TITLES.ACCESS_DENIED} />
      <div className={cs(classes.container)}>
        <div className={classes.card}>
          <div className={classes.iconCircle}>
            <svg
              className={classes.icon}
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <circle
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="2"
              />
              <line
                x1="5"
                y1="5"
                x2="19"
                y2="19"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </div>
          <h2 className={classes.title}>Your access has been suspended</h2>
          <p className={classes.paragraph}>
            This account or connection has been restricted due to a policy
            violation.
          </p>
          <a
            className={classes.link}
            href={`https://docs.google.com/forms/d/e/1FAIpQLSdP4wV8R5Ef9d62HYeQ6Np3oL3e0vni9RBNpfs7M-gR0m9MhQ/viewform?entry.846118776=${ip}`}

          >
            Contact Maor about this decision <span aria-hidden="true">&rarr;</span>
          </a>
        </div>
      </div>
    </>
  );
};

AccessDenied.propTypes = {
  ip: PropTypes.string,
};

export default React.memo(AccessDenied);
